"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function scopeOfElement(mana) {
    if (mana.__memory.scope) {
        return mana.__memory.scope;
    }
    if (mana.__memory && mana.__memory.parent) {
        return scopeOfElement(mana.__memory.parent);
    }
    return null;
}
exports.default = scopeOfElement;
//# sourceMappingURL=scopeOfElement.js.map